<template>
  <v-container>
    <v-card class="login">
      <Loader :loading="loading" :absolute="true" />
      <div class="text-xs-center">
        <img src="img/logo.png" width="90" class="mt-5" alt />
      </div>
      <v-card-text>
        <v-text-field label="Email" v-model="email" outlined></v-text-field>
        <v-text-field label="Пароль" v-model="password" outlined type="password"></v-text-field>
      </v-card-text>
      <div class="text-xs-center">
        <v-btn color="success" class="mb-4" text @click="login">Войти в систему</v-btn>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import { mapMutations } from "vuex";
import Loader from "../components/helper/Loader";

export default {
  components: { Loader },
  data: () => ({
    loading: false,
    email: "",
    password: ""
  }),
  name: "Login",
  methods: {
    ...mapMutations(["SET_ISLOGIN", "SET_LANGUAGE"]),
    async login() {
      this.loading = true;
      await axios
        .post("admin/auth", {
          email: this.email,
          password: this.password
        })
        .then(response => {
          if (response.data.token) {
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("email", response.data.client.email);
            window.axios.defaults.headers.common[
              "Authorization"
            ] = `Bearer ${response.data.token}`;
            this.SET_LANGUAGE("ru");
            this.SET_ISLOGIN(true);
            // this.$store.dispatch('setBrand',response.data.client.brand);

            if (response.data.client.menu.length) {
              setTimeout(() => {
                this.$router.push({ path: response.data.client.menu[0].path });
              }, 600);
            }


          }
        })
        .catch(error => {
          window.axios.defaults.headers.common["Authorization"] = "";
          this.$toast.error({
            title: "Ошибка",
            message: "Неверный email или пароль"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
